/* eslint i18next/no-literal-string: 0 */
import React from 'react'
import { Link } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { closeMenu, switchPageLoading } from '../../../store/common/commonSlice'
import { createLocalizedPath } from '../../../utils/localizationHelpers'
import paths from '../../../paths'

import {
    IconHome,
    IconMapPin,
    IconUsers,
    IconPhoto,
    IconClock24,
    IconCameraPin,
    IconMessages,
    IconSearch,
    IconArchive,
    IconChevronRight,
    IconCertificate,
    IconHeartUp
} from '@tabler/icons-react'

const MenuNewCenter: React.FC = () => {
    const [t] = useTranslation()
    const dispatch = useDispatch()

    const handleMenuClick = () => {
        dispatch(closeMenu())
        dispatch(switchPageLoading())
    }

    const sections = [
        {
            items: [
                {
                    label: t('Home'),
                    icon: <IconHome size={20} />,
                    path: createLocalizedPath(paths.index.path),
                    isLink: true,
                    isHref: true,
                    desktopOnly: true
                }
            ]
        },
        {
            title: t('Content'),
            items: [
                {
                    label: t('Ephemeral stories'),
                    icon: <IconClock24 size={20} />,
                    path: createLocalizedPath(paths.temporaryPhotos.path),
                    isLink: true
                },
                {
                    label: t('Flashing'),
                    icon: <IconCameraPin size={20} />,
                    path: createLocalizedPath(paths.flashing.path),
                    isLink: true,
                    isNew: true
                },
                {
                    label: t('Top contributions'),
                    icon: <IconHeartUp size={20} />,
                    path: createLocalizedPath(paths.indexPopular.path),
                    isLink: false,
                    isHref: true
                },
                {
                    label: t('The best photos'),
                    icon: <IconPhoto size={20} />,
                    path: createLocalizedPath(paths.indexBestPhotos.path),
                    isLink: true
                },
                {
                    label: t('Search content'),
                    icon: <IconSearch size={20} />,
                    path: createLocalizedPath('/tags/'),
                    isLink: true
                },
                {
                    label: t('Archive'),
                    icon: <IconArchive size={20} />,
                    path: createLocalizedPath('/archive/'),
                    isLink: true
                }
            ]
        },
        {
            title: t('Community'),
            items: [
                {
                    label: t('Forum'),
                    icon: <IconMessages size={20} />,
                    path: '/forum/',
                    isLink: false,
                    isExternal: true
                },
                {
                    label: t('Profiles'),
                    icon: <IconUsers size={20} />,
                    path: createLocalizedPath(paths.profiles.path),
                    isLink: true
                },
                {
                    label: t('Certified females and couples'),
                    icon: <IconCertificate size={20} />,
                    path: createLocalizedPath(paths.indexCertifiedFemAndCouple.path),
                    isLink: true
                },

                {
                    label: t('Around me'),
                    icon: <IconMapPin size={20} />,
                    path: createLocalizedPath(paths.geo.path),
                    isLink: true
                }
            ]
        }
    ]

    const renderItem = (item: (typeof sections)[0]['items'][0]) => {
        const content = (
            <>
                <span className="menuNewCenter__itemIcon">{item.icon}</span>
                <span className="menuNewCenter__itemLabel">{item.label}</span>
                {/*@ts-ignore*/}
                {item.isNew && <span className="menuNewCenter__new">{t('new_section')}</span>}
                <IconChevronRight size={16} className="menuNewCenter__itemArrow" />
            </>
        )

        // @ts-ignore
        if (item.isExternal) {
            return (
                <a
                    key={item.label}
                    href={item.path}
                    target="_blank"
                    rel="noreferrer"
                    //@ts-ignore
                    className={`menuNewCenter__item ${item.desktopOnly ? 'desktopOnly' : ''}`}
                    onClick={handleMenuClick}
                >
                    {content}
                </a>
            )
        }

        // @ts-ignore
        if (item.isHref) {
            return (
                <a
                    key={item.label}
                    href={item.path}
                    //@ts-ignore
                    className={`menuNewCenter__item ${item.desktopOnly ? 'desktopOnly' : ''}`}
                    onClick={handleMenuClick}
                >
                    {content}
                </a>
            )
        }

        return (
            <Link
                key={item.label}
                to={{ pathname: item.path }}
                className="menuNewCenter__item"
                onClick={handleMenuClick}
            >
                {content}
            </Link>
        )
    }

    return (
        <div className="menuNewCenter">
            {sections.map((section, index) => (
                <div key={index} className="menuNewCenter__section">
                    {section.title && <p className="menuNewCenter__title">{section.title}</p>}
                    <div className="menuNewCenter__items">{section.items.map(renderItem)}</div>
                </div>
            ))}
        </div>
    )
}

export default MenuNewCenter
